import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';
import { AppProfileService } from './app-profile.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceCreateService { 
    private apiUrl =  this.appProfile.ampmUs+'/ems/fhir/'+this.appProfile.org+'/Device';

  constructor(private http: HttpClient, private authService: AuthService, private appProfile: AppProfile) { }

  private headers = new HttpHeaders({
    'X-tenant-Id': this.appProfile.tenant,
    'api-version': '1.0.0',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.authService.accessToken}`,
  });

  createDevice(serialNumber: string) {
    const payload = {
      resourceType: 'Device',
      meta: {
        profile: [
          'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmDevice'
        ]
      },
      text: {
        status: 'generated',
        div: '<div xmlns="http://www.w3.org/1999/xhtml"><p><b>Generated Narrative with Details</b></p><p><b>id</b>: f001</p><p><b>identifier</b>: 12345</p><p><b>status</b>: active</p></div>'
      },
      implicitRules: 'de99167a-c570-4536-941b-b9f9189c477e',
      status: 'active',
      manufacturer: 'philips',
      manufactureDate: '2018-11-19T20:36:09.001-05:01',
      expirationDate: '2028-11-19T20:36:09.001-05:01',
      serialNumber: serialNumber,
      deviceName: [{ name: 'dev562r001', type: 'other' }],
      modelNumber: 'A1-FXAC1193',
      type: {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem',
            code: '156009',
            display: 'Spine board'
          }
        ],
        text: 'Spine'
      },
      extension: [
        {
          url: 'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmFamilyNameExtension',
          valueString: 'generic family name'
        },
        {
          url: 'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmSubFamilyNameExtension',
          valueString: 'generic sub family name'
        },
        {
          url: 'https://www.fhir.philips.com/4.0/uv/ampm/StructureDefinition/AmpmDeliveryMethodExtension',
          valueCodeableConcept: {
            coding: [
              {
                system:
                  'https://www.fhir.philips.com/4.0/uv/ampm/CodeSystem/AmpmDeliveryMethodCodeSystem',
                code: 'modem',
                display: 'modem'
              }
            ]
          }
        }
      ]
    };

    return this.http.post(this.apiUrl, payload, { headers: this.headers });
  }
}
